import React from "react";
import { imageUrl, srcSet } from "./projects";

// AVIF first, WebP fallback. Explicit width/height let the browser reserve
// space before the file arrives, so nothing jumps around while loading.
function ProjectPicture({ project, image, sizes, alt, loading = "lazy", className = "", ...rest }) {
  return (
    <picture>
      <source type="image/avif" srcSet={srcSet(project, image, "avif")} sizes={sizes} />
      <source type="image/webp" srcSet={srcSet(project, image, "webp")} sizes={sizes} />
      <img
        src={imageUrl(project, image, image.width, "webp")}
        width={image.width}
        height={image.height}
        alt={alt}
        loading={loading}
        decoding="async"
        className={className}
        {...rest}
      />
    </picture>
  );
}

export default ProjectPicture;
